import { Button, Field, Input, LanguagePicker, useI18n } from '@upweo/ui';
import { type FormEvent, useState } from 'react';

import { ApiClientError } from '../lib/api-client.js';
import { useAuth } from '../lib/auth-context.js';

export const LoginPage = ({ onCreateStore }: { onCreateStore: () => void }): React.JSX.Element => {
  const { signIn } = useAuth();
  const { t } = useI18n();
  const [email, setEmail] = useState('owner@northwind.test');
  const [password, setPassword] = useState('Password123!');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    setError(null);
    setBusy(true);
    void (async () => {
      try {
        await signIn(email, password);
      } catch (err) {
        setError(
          err instanceof ApiClientError ? err.error.message : 'Something went wrong. Try again.',
        );
      } finally {
        setBusy(false);
      }
    })();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <div className="w-full max-w-sm rounded-xl border bg-card p-8 shadow-md">
        <h1 className="text-2xl font-semibold tracking-tight">Upweo</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('auth.signInSubtitle')}</p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <Field label={t('common.email')} htmlFor="email">
            <Input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </Field>

          <Field label={t('common.password')} htmlFor="password">
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </Field>

          {error && (
            <p
              role="alert"
              className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive"
            >
              {error}
            </p>
          )}

          <Button type="submit" disabled={busy} className="w-full">
            {busy ? t('auth.signingIn') : t('auth.signIn')}
          </Button>
        </form>

        <p className="mt-6 border-t pt-4 text-sm text-muted-foreground">
          <button
            type="button"
            onClick={onCreateStore}
            className="text-primary underline-offset-4 hover:underline"
          >
            {t('auth.needAccount')}
          </button>
        </p>
        <p className="mt-2 text-xs text-muted-foreground">
          The seeded demo account is pre-filled and belongs to <strong>two</strong> stores, so you
          can try the store switcher.
        </p>
        <div className="mt-4 flex justify-center border-t pt-4">
          <LanguagePicker />
        </div>
      </div>
    </div>
  );
};
